import React from 'react';
import classNames from 'classnames';
import { PlusIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import * as styles from './SuggestedQuestion.ve.css';

interface SuggestedQuestionProps {
  question: string;
  onSelect: (question: string) => void;
  disabled?: boolean;
}

export const SuggestedQuestion: React.FC<SuggestedQuestionProps> = ({ question, onSelect, disabled = false }) => (
  <Stack
    gap="2"
    alignItems="center"
    onClick={disabled ? undefined : () => onSelect(question)}
    cursor={disabled ? 'notAllowed' : 'pointer'}
    className={classNames({
      [styles.suggestedQuestion]: !disabled,
    })}
    role="button"
  >
    <PlusIcon size="sm" color={disabled ? 'grey_800' : 'grey_1200'} />
    <Typography color={disabled ? 'grey_800' : 'grey_1200'} size="b_sm">
      {question}
    </Typography>
  </Stack>
);
